export const CREATE_REACTION_EVENT = 'create-reaction'
export const UPDATE_REACTION_EVENT = 'update-reaction'
export const LOAD_NOTIFICATIONS_EVENT = 'load-notifications'
export const MARK_NOTIFICATIONS_READ_EVENT = 'mark-notifications-read'
export const NOTIFICATIONS_UNREAD_COUNT_EVENT = 'notifications-unread-count'
export const LOAD_STORY_ACTIVITY = 'load-story-activity'
export const MARK_STORIES_READ = 'mark-stories-read'
export const STORIES_UNREAD_COUNTER = 'stories-unread-count'
